import { type CSSProperties, forwardRef } from "react";

import { cn } from "../utils";
import { Textarea } from "./textarea";

export type AutoresizingTextareaProps = React.ComponentPropsWithRef<"textarea"> & {
  children?: React.ReactNode;
};

export const AutoresizingTextarea = forwardRef<HTMLTextAreaElement, AutoresizingTextareaProps>(
  ({ children, className, rows = 1, ...props }, ref) => (
    <div className="grid relative">
      <div className={cn(className, "pointer-events-none invisible whitespace-pre-wrap")} style={style}>
        {props.value}
        <br />
      </div>
      <Textarea
        ref={ref}
        rows={rows}
        style={style}
        {...props}
        className={cn("resize-none placeholder:truncate placeholder-shown:truncate", className)}
      />
      {children}
    </div>
  )
);

AutoresizingTextarea.displayName = "AutoresizingTextarea";

const style: CSSProperties = { gridArea: "1 / 1 / 2 / 2", overflowWrap: "anywhere" };
